import React from 'react';
import { contact } from './ResumeData';

export function ContactInfo() {
  return (
    <main className="ContactInfo">
      <h2>Contact Information</h2>
      <section className="card text-start">
        <div className="card-body">
          <p><strong>Location:</strong> {contact.location}</p>
          <p><strong>Phone:</strong> <a href="tel:+14433374042">{contact.phone}</a></p>
          <p><strong>Email:</strong> {contact.emails.map((email, index) => <React.Fragment key={email}>{index > 0 && ' | '}<a href={`mailto:${email}`}>{email}</a></React.Fragment>)}</p>
          <p><strong>LinkedIn:</strong> <a href={contact.linkedin} target="_blank" rel="noreferrer">Darius Quick</a></p>
          <p><strong>Work Authorization:</strong> {contact.workAuthorization}</p>
        </div>
      </section>
    </main>
  );
}
